import React from 'react';
import './styles.css';

const Sejarah = ({ content }) => {
  return (
    <section className="section">
      <div className="container">
        <h2>Sejarah Singkat</h2>
        <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }} dangerouslySetInnerHTML={{ __html: content?.sejarah?.replace(/\n/g, '<br />') || "Sejarah singkat sekolah belum diatur." }}>
        </p>
      </div>
    </section>
  );
};

export default Sejarah;